import React from 'react';
import axios from 'axios';
import { RefreshCw, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const reportClientError = (payload) => {
  try {
    axios.post(`${API}/client-errors`, { url: window.location.href, ...payload }).catch(() => {});
  } catch (e) { /* never throw from the reporter */ }
};

// Attrape tout plantage React : plus d'écran blanc, message clair + bouton Recharger, erreur journalisée côté serveur
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    reportClientError({ kind: 'react', message: error?.message || String(error), stack: error?.stack || '', component_stack: info?.componentStack || '' });
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white border-2 border-red-200 rounded-3xl p-6 space-y-4 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-red-50 flex items-center justify-center"><AlertTriangle className="text-red-600" size={28} /></div>
          <h1 className="font-heading text-xl font-bold text-gray-900">Oups, un problème est survenu</h1>
          <p className="text-sm text-gray-600">L'erreur a été enregistrée pour analyse. Vos données sont conservées.</p>
          <p className="text-xs text-gray-400 font-mono break-words" data-testid="error-boundary-message">{String(this.state.error?.message || this.state.error)}</p>
          <button type="button" onClick={() => window.location.reload()} className="w-full h-12 rounded-full bg-neon-pink text-gray-900 font-semibold inline-flex items-center justify-center gap-2" data-testid="error-boundary-reload-btn">
            <RefreshCw size={18} />Recharger l'application
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
